import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { faCheckCircle, faEnvelope, faTimesCircle, } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { selectUserLoader } from '@src/app/store/selectors';
import { AuthService } from '@src/app/services/user-managment/authentication/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
    @Output() clickCancel = new EventEmitter<null>();


  faTimesCircle = faTimesCircle;
  faCheckCircle =faCheckCircle;
  faEnvelope= faEnvelope;
  showPassword = false ; 
  showConfirmPassword = false;

  userLoader$ = this.store.select(selectUserLoader);
  userLoader : boolean = false;

  forgetPassForm = new FormGroup({
    'Email': new FormControl('', [Validators.email, Validators.minLength(8), Validators.required]),
  })

  constructor(
    public translate : TranslateService,
    public dialog    : MatDialog,
    public authService : AuthService,
    public store: Store
  ) { }

ngOnInit(): void {
    this.authService.initForgetPasswordForm()
  }

  onSubmit(){
    this.authService.forgetPassword()
    Swal.fire({
      title: this.translate.instant('success'),
      icon: 'success',
    })
  }

  onClickCancel(){
    this.clickCancel.emit(null)
  }

  
  get lang() {
    return this.translate.currentLang === 'en' ? 'en' : 'ar';
  }

  get isLoading() {
    return this.authService.isLoading;
  }

  get forgetPasswordForm() {
    return this.authService.forgetPasswordForm;
  }

  get getEmailErrorMessage() {
    return this.authService.getEmailErrorMessage;
  }


  closeDialog(){
    this.dialog.closeAll()
  }
  toggleShowPassword(){
    this.showPassword = !this.showPassword; 
  }
  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

}
